import { useServers } from '../hooks/use-servers.js';
import { ServerCard } from '../components/server-card.js';

function ServerCardSkeleton() {
  return (
    <div className="card animate-pulse p-4">
      <div className="flex items-start justify-between">
        <div>
          <div className="h-4 w-32 rounded" style={{ backgroundColor: 'var(--color-surface-3)' }} />
          <div className="mt-2 h-3 w-20 rounded" style={{ backgroundColor: 'var(--color-surface-3)' }} />
        </div>
        <div className="h-6 w-16 rounded-full" style={{ backgroundColor: 'var(--color-surface-3)' }} />
      </div>
      <div className="mt-4 space-y-2">
        <div className="h-2 w-full rounded" style={{ backgroundColor: 'var(--color-surface-3)' }} />
        <div className="h-2 w-full rounded" style={{ backgroundColor: 'var(--color-surface-3)' }} />
        <div className="h-2 w-full rounded" style={{ backgroundColor: 'var(--color-surface-3)' }} />
      </div>
    </div>
  );
}

export function Servers() {
  const { data: servers, isLoading, error } = useServers();

  return (
    <div>
      <div className="mb-6">
        <h1 className="page-title text-2xl">Servers</h1>
        <p className="mt-1 text-sm" style={{ color: 'var(--color-text-2)' }}>Manage your development servers.</p>
      </div>

      {error && (
        <div className="rounded-lg border p-4 text-sm" style={{ borderColor: 'var(--color-error)', backgroundColor: 'var(--color-error-dim)', color: 'var(--color-error)' }}>
          Failed to load servers: {error.message}
        </div>
      )}

      {isLoading && (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {[0, 1, 2].map((i) => <ServerCardSkeleton key={i} />)}
        </div>
      )}

      {servers && servers.length === 0 && (
        <div className="rounded-xl border-2 border-dashed p-12 text-center" style={{ borderColor: 'var(--color-border-2)' }}>
          <svg className="mx-auto h-12 w-12" style={{ color: 'var(--color-text-3)' }} fill="none" viewBox="0 0 24 24" strokeWidth={1} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M5.25 14.25h13.5m-13.5 0a3 3 0 01-3-3m3 3a3 3 0 100 6h13.5a3 3 0 100-6m-16.5-3a3 3 0 013-3h13.5a3 3 0 013 3m-19.5 0a4.5 4.5 0 01.9-2.7L5.737 5.1a3.375 3.375 0 012.7-1.35h7.126c1.062 0 2.062.5 2.7 1.35l2.587 3.45a4.5 4.5 0 01.9 2.7m0 0a3 3 0 01-3 3m0 3h.008v.008h-.008v-.008zm0-6h.008v.008h-.008v-.008zm-3 6h.008v.008h-.008v-.008zm0-6h.008v.008h-.008v-.008z" />
          </svg>
          <h3 className="mt-3 text-sm font-semibold" style={{ color: 'var(--color-text)' }}>No servers</h3>
          <p className="mt-1 text-sm" style={{ color: 'var(--color-text-3)' }}>No servers are configured for your organization.</p>
        </div>
      )}

      {servers && servers.length > 0 && (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {servers.map((server) => (
            <ServerCard key={server.id} server={server} />
          ))}
        </div>
      )}
    </div>
  );
}
